/**
 * Gets the origin as interpretted by an anchor tag's href
 * This supports protocol-relative urls as well as full Location objects
 * @param {string} url - the input url
 * @returns {string} the evaluated origin of a url
 */
function getLocationOrigin(url) {
  const anchor = document.createElement('a')
  anchor.href = url
  return anchor.origin
}

/**
 * Evaluates if two urls have the same origin
 * Supports protocol-relative matching and Location object matching
 * @param {Location|string} urlA
 * @param {Location|string} urlB
 * @returns {Boolean} - whether or not the url origins match
 */
export default function isSameOrigin(urlA, urlB) {
  const originA = getLocationOrigin(urlA)
  const originB = getLocationOrigin(urlB)
  return originA === originB
}
